import detailPromotionPresentation from "@/controllers/estimates/detailPromotionPresentation";
import detailRequestPresentation from "@/controllers/estimates/detailRequestPresentation";

export default {
  computed: {
    ...detailRequestPresentation.computed,
    ...detailPromotionPresentation.computed,
  },
  watch: {
    ...detailPromotionPresentation.watch,
  },
};
